module.exports = __webpack_public_path__ + "img/image 22.861dba23.png";